import { Link } from "react-router-dom";
import CountUp from 'react-countup';
import { useEffect, useState } from "react";
import api from "../services/api";

// Cache dos tipos para não ir buscar 18x à API (um por cada cartão)
let tiposCached = null;

export default function ServicesMenuControlGeral({ provincia, icone }) {
  const [total, setTotal]   = useState(0);
  const [tipos, setTipos]   = useState([]); // [{ _id, nome, count }]
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        // 1. Buscar tipos de estabelecimento (usa cache se já tiver sido buscado)
        if (!tiposCached) {
          const res = await api.get('/tipo-estabelecimentos');
          tiposCached = res.data.tipoEstabelecimentos ?? [];
        }
        const tiposList = tiposCached;

        // 2. Buscar total + contagem por tipo (em paralelo)
        const [totalRes, ...tipoResults] = await Promise.all([
          api.get(`/estabelecimentos?provincia=${provincia}&count=true`),
          ...tiposList.map(t =>
            api.get(`/estabelecimentos?provincia=${provincia}&tipoId=${t._id}&count=true`)
              .catch(() => ({ data: { totalItems: 0 } }))
          ),
        ]);

        if (cancelled) return;

        setTotal(totalRes.data.totalItems ?? 0);
        setTipos(
          tiposList.map((t, i) => ({
            _id:   t._id,
            nome:  t.designacao ?? t.nome ?? t.name ?? t.tipo ?? `Tipo ${i + 1}`,
            count: tipoResults[i]?.data?.totalItems ?? 0,
          }))
        );
      } catch (_) {}
      finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => { cancelled = true; };
  }, [provincia]);

  return (
    <Link
      to={`/admin/provincia/${provincia}`}
      className={[
        'tw-flex tw-flex-col',
        'tw-w-[260px] tw-min-w-[240px] tw-no-underline',
        'tw-bg-white tw-rounded-xl tw-border tw-border-gray-200',
        'tw-shadow-sm tw-transition-all tw-duration-300',
        'hover:tw-shadow-md hover:tw--translate-y-0.5 hover:tw-border-[#85287e]/40',
        'tw-overflow-hidden tw-cursor-pointer',
      ].join(' ')}
    >
      {/* Cabeçalho: mapa + nome + total */}
      <div className="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-4 tw-border-b tw-border-gray-100">
        <div className="tw-flex-shrink-0 tw-bg-[#85287e]/5 tw-rounded-xl tw-p-2">
          <img
            src={icone}
            alt={provincia}
            className="tw-w-14 tw-h-14 tw-object-contain"
          />
        </div>
        <div className="tw-flex-1 tw-min-w-0">
          <p className="tw-text-[13px] tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wide tw-truncate">
            {provincia}
          </p>
          <p className="tw-text-sm tw-text-gray-400 tw-font-medium tw-mt-0.5">
            Total: <span className="tw-font-extrabold tw-text-[#85287e] tw-text-base">
              {loading ? '···' : <CountUp end={total} />}
            </span>
          </p>
        </div>
      </div>

      {/* Subtotais dinâmicos por tipo */}
      <div className="tw-px-4 tw-py-3 tw-flex tw-flex-col tw-gap-2">
        {loading ? (
          <div className="tw-flex tw-gap-2 tw-animate-pulse">
            {[1, 2, 3].map(i => (
              <div key={i} className="tw-flex-1 tw-h-10 tw-bg-gray-100 tw-rounded-md" />
            ))}
          </div>
        ) : tipos.length === 0 ? (
          <p className="tw-text-xs tw-text-gray-400 tw-py-2">Sem tipos definidos</p>
        ) : (
          <>
            <div className="tw-grid tw-grid-cols-2 tw-gap-2">
              {tipos.slice(0, 4).map(tipo => (
                <div
                  key={tipo._id}
                  className="tw-flex tw-flex-col tw-items-center tw-bg-gray-50 tw-rounded-lg tw-py-2 tw-px-2"
                >
                  <span className="tw-text-[10px] tw-text-gray-400 tw-font-semibold tw-uppercase tw-leading-none tw-truncate tw-w-full tw-text-center tw-mb-1">
                    {tipo.nome.length > 12 ? tipo.nome.substring(0, 11) + '.' : tipo.nome}
                  </span>
                  <span className="tw-text-base tw-font-extrabold tw-text-[#85287e]">
                    <CountUp end={tipo.count} />
                  </span>
                </div>
              ))}
            </div>

            {tipos.length > 4 && (
              <div className="tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-400 tw-pt-1">
                <span>+{tipos.length - 4} outros tipos</span>
                <span className="tw-font-bold tw-text-gray-600">
                  <CountUp end={tipos.slice(4).reduce((s, t) => s + t.count, 0)} />
                </span>
              </div>
            )}
          </>
        )}
      </div>
    </Link>
  );
}
